/**
 * useDesignSystemTheme - Shared theme hook for all design system components
 *
 * Handles theme detection consistently across:
 * - Production app (uses resolvedTheme from next-themes)
 * - Storybook (uses forcedTheme)
 * - SSR (defaults to "light" to avoid hydration mismatch)
 */

import { useTheme } from "next-themes"

export type Theme = "light" | "dark"

export function useDesignSystemTheme(): Theme {
  const { resolvedTheme, forcedTheme } = useTheme()

  // Priority: forcedTheme (Storybook) > resolvedTheme > default "light"
  const theme = forcedTheme || resolvedTheme || "light"

  return theme === "dark" ? "dark" : "light"
}
